import React, { useState, useEffect } from 'react'
import { Route } from 'react-router-dom'

const BACKEND_URL = process.env.REACT_APP_API_BASE
const baseUrl = window.location.origin;

const NotLoggedIn = () => (
    <div
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontFamily: 'sans-serif',
            padding: '20px',
            textAlign: 'center',
        }}
    >
        <div>
            <h2 style={{ color: '#333', marginBottom: '16px' }}>
                Not Logged In
            </h2>
            <p style={{ color: '#555', fontSize: '1.1rem' }}>
                You're not logged in. Please go to{' '}
                <a
                    href={`${baseUrl}/makeAdmin`}
                    style={{ color: '#1a73e8' }}
                >
                    {`${baseUrl}/makeAdmin`}
                </a>{' '}
                and log in again.
            </p>
        </div>
    </div>
)

const PreviewProtectedRoute = ({
    component: Component,
    render: renderProp,
    ...rest
}) => {
    const [user, setUser] = useState(null)
    const [authChecked, setAuthChecked] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        if (params.get('preview') === 'true') {
            fetch(`${BACKEND_URL}/me`, { credentials: 'include' })
                .then((res) => res.json())
                .then((data) => {
                    setUser(data)
                    setAuthChecked(true)
                })
                .catch(() => {
                    setUser(null)
                    setAuthChecked(true)
                })
        } else {
            setAuthChecked(true)
            setUser(true)
        }
    }, [])

    return (
        <Route
            {...rest}
            render={(props) => {
                const params = new URLSearchParams(props.location.search)
                const isPreview = params.get('preview') === 'true'

                if (isPreview) {
                    if (!authChecked)
                        return (
                            <div
                                style={{
                                    padding: '20px',
                                    textAlign: 'center',
                                }}
                            >
                                Checking authorization...
                            </div>
                        )
                    if (!user) return <NotLoggedIn />
                }

                if (renderProp) return renderProp(props)
                return <Component {...props} />
            }}
        />
    )
}

export default PreviewProtectedRoute
